import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
const TOTAL_SECONDS = 17 * 60 + 34;
function Unit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-73" data-mp="3l1j2e738kwmw">
      <span className="min-w-[58px] rounded-xl bg-navy-950 px-3 py-2 text-center font-display text-2xl font-bold tabular-nums text-gold-400 sm:min-w-[70px] sm:text-3xl" data-id="element-74" data-mp="3l0q3ttefldfu">
        {value}
      </span>
      <span className="mt-1 text-[9px] font-bold uppercase tracking-widest text-navy-800/60 sm:text-[10px]" data-id="element-75" data-mp="3c48qqkmib5hg">
        {label}
      </span>
    </div>;
}
export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(TOTAL_SECONDS);
  return <div className="mx-auto mt-5 w-full max-w-sm rounded-2xl border border-gold-500/40 bg-gold-400/15 px-4 py-4" data-id="element-76" data-mp="373kr5ak7pgbm">
      <p className="flex items-center justify-center gap-1.5 text-[11px] font-extrabold uppercase tracking-wider text-navy-900 sm:text-xs" data-id="element-77" data-mp="10d4s3w3symmd">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-78" data-mp="y0wtdi1dlqiw" />
        Esta oferta expira en
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" role="timer" aria-live="off" data-id="element-79" data-mp="t2d5vd74w6of">
        <Unit value={hours} label="Horas" data-id="element-80" data-mp="17poh1dzeloo0" />
        <span className="pt-2 font-display text-2xl font-bold text-navy-900/40" data-id="element-81" data-mp="17ssruu7djinn">:</span>
        <Unit value={minutes} label="Min" data-id="element-82" data-mp="12tzovvppra1q" />
        <span className="pt-2 font-display text-2xl font-bold text-navy-900/40" data-id="element-83" data-mp="f1spsoslsoym">:</span>
        <Unit value={seconds} label="Seg" data-id="element-84" data-mp="a3hgcf680ggx" />
      </div>
    </div>;
}